//Sepete Ekle //
function sepetyaz(urunId, barkod, ithalat, birimfiyat, indirimli, kdv, birim, indirim1, txtAdet1, kimyazdi) {

}

//Enter ile sepete ekleme Başlangıç //
$(document).on("keypress", ".sepet", function (e) {
  if (e.which == 13) {
    $("#btn" + this.id.replace("Adet", "")).click();
    return false;
  }
});
//Enter ile sepete ekleme Bitiş //


//Sepete Ekle //

//Sepet Adet//





//Giriş //

$("#btnGiris").click(function () {
  if ($("#txtKullaniciAd").val() == '') {
    toastr['error']("Eposta boş olamaz.", "Uyarı!", {
      "closeButton": false,
      "debug": false,
      "positionClass": "toast-top-right",
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    });
  } else if ($("#txtSifre").val() == '') {
    toastr['error']("Şifre boş olamaz.", "Uyarı!", {
      "closeButton": false,
      "debug": false,
      "positionClass": "toast-top-right",
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    });
  } else {
    $.ajax({
      type: 'POST',
      url: '/WebMethods.aspx/KullaniciKontrolMusteri',
      data: '{"KullaniciAd":"' + $("#txtKullaniciAd").val() + '","Sifre":"' + $("#txtSifre").val() + '"}',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: function (result) {
        if (result.d == '-1') {
          toastr['error']("Bilgilerinizi kontrol edip, tekrar deneyiniz.", "Uyarı!", {
            "closeButton": false,
            "debug": false,
            "positionClass": "toast-top-right",
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          });
        } else if (result.d == '0') {
          //toastr['error']("Hesabınız pasif durumda.", "Uyarı!", { "closeButton": false, "debug": false, "positionClass": "toast-top-right", "onclick": null, "showDuration": "300", "hideDuration": "1000", "timeOut": "5000", "extendedTimeOut": "1000", "showEasing": "swing", "hideEasing": "linear", "showMethod": "fadeIn", "hideMethod": "fadeOut" });
          $('#divPasif').empty();

          $('#divPasif').attr("style", "z-index: 9999999; border:7px solid #000; background-color:#fff; border-radius:8px; padding:20px; width:700px;font-size:18px;height:300px;");

          $('#divPasif').append("<div align='right'><img border='0' height='82' width='131' src='public/images/maillogo.png' class='CToWUd'></div><p style='font-family:Verdana;font-size:15px;font-weight: bold;'>Değerli Müşterimiz,</p><br><p style='font-family:Verdana;font-size:15px;font-weight: bold;'>Cari hesabınızla ilgili finans departmanı ile görüşmenizi rica ederiz.</p>");

          $('#divPasif').bPopup({
            appendTo: 'form',
            zIndex: 999999,
            modalClose: true
          });
        } else if (result.d == '-2') {
          toastr['error']("Müşteriye özel alan.", "Uyarı!", {
            "closeButton": false,
            "debug": false,
            "positionClass": "toast-top-right",
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          });
        } else {
          var expires_day = 365;
          if ($('#beniHatirla').is(':checked')) {
            $.cookie('pm[email]', $('#txtKullaniciAd').val(), {
              expires: expires_day
            });
            $.cookie('pm[password]', $('#txtSifre').val(), {
              expires: expires_day
            });
            $.cookie('pm[remember]', true, {
              expires: expires_day
            });
          } else {
            $.cookie('pm[email]', null);
            $.cookie('pm[password]', null);
            $.cookie('pm[remember]', false);
          }
          window.location.href = window.location.href.split('#')[0];
        }
      },
      error: function (resultx) {
        toastr['error']("", "Uyarı!", {
          "closeButton": false,
          "debug": false,
          "positionClass": "toast-top-right",
          "onclick": null,
          "showDuration": "300",
          "hideDuration": "1000",
          "timeOut": "5000",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "fadeIn",
          "hideMethod": "fadeOut"
        });
      }
    });
  }
  return false;
});
//Giriş Bitiş//

//Arama enter Tuşu//
$(document).on("onclick", "#btnListele", function (e) {
  Arama();
  return false;
});

function Arama() {
  if ($("#txtArama").val().trim() != ' Kitap / Yazar / Yayınevi / Barkod'.trim() && $("#txtArama").val() != '') {

    if ($("#txtArama").val().length > 2) {
      if ($.trim($("#txtArama").val()).length == 13 & parseFloat($.trim($("#txtArama").val().replace("'", " "))) > 0) {
        window.location.href = '/Istem/Urun/Detay.aspx?Barcode=' + $.trim($("#txtArama").val().replace("'", " "));
      } else {
        window.location.href = '/Istem/Urun/Listele.aspx?ara=' + $("#txtArama").val() + '&yazar=0&yayinEvi=0';
      }
    } else {
      toastr['error']("Arama için en az 3 harf gerekli.", "Uyarı!", {
        "closeButton": false,
        "debug": false,
        "positionClass": "toast-top-right",
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
      });
    }
  }
}
//Arama enter Tuşu Bitiş//

//Beni Hatırla
$(document).ready(function () {

  //   var remember = $.cookie('pm[remember]');
  if ($.cookie('pm[email]') != 'null') {
    $('#txtKullaniciAd').val($.cookie('pm[email]'));
    $('#txtSifre').val($.cookie('pm[password]'));
    $('#beniHatirla').attr("checked", true);
    $('#uniform-beniHatirla > span').attr("class", 'checked');
  }

  $('.para').priceFormat({
    prefix: '',
    suffix: ' TL',
    centsSeparator: ',',
    thousandsSeparator: '.'
  });


  $('.maxlength_placement').maxlength({
    alwaysShow: true,
    placement: 'top-left',
    limitReachedClass: "label label-danger",
  });
});

function ParaFormat() {
  $('.para').priceFormat({
    prefix: '',
    suffix: ' TL',
    centsSeparator: ',',
    thousandsSeparator: '.'
  });
}
//Beni Hatırla

//Gerekli
$(document).ready(function () {
  //Büyük Harf //
  $('.buyukHarf').bestupper({
    ln: 'tr'
  });
  //Büyük Harf Bitiş//

  //Sayı Validate Başlangıç//
  $(".sayi").inputmask('integer', {
    rightAlignNumerics: false
  });
  $(".sayiOndalik").inputmask('decimal', {
    rightAlignNumerics: false,
    radixPoint: ","
  });
  //Sayı Validate Bitiş//

  //Büyük Harf Başlangıç//
  $('.buyukHarf').keyup(function () {
    this.value = this.value.toUpperCase();
  });
  //Büyük Harf Bitiş//

  $(".telefon").inputmask("mask", {
    "mask": "(0999) 999-99-99"
  });

  $(function () {
    $.datepicker.setDefaults($.datepicker.regional['tr']);
    $('.date-picker').datepicker({
      dateFormat: 'dd.mm.yy'
    });
  });

  ParaFormat();

});
//Gerekli

//Querystring Parametre
function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
//Querystring Parametre

$("#txtArama").autocomplete({
  source: function (request, response) {
    var aciklama = {
      aciklama: $('#txtArama').val().replace("'", " ")
    };
    $.ajax({
      url: '/WebMethods.aspx/UrunListeleFiltrele',
      data: JSON.stringify(aciklama),
      dataType: "json",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataFilter: function (data) {
        return data;
      },
      success: function (data) {
        response($.map(data.d, function (item) {
          return {
            value: data.d
          }
        }))
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        //   alert(textStatus);
      }
    });
  },
  minLength: 3
}).data("ui-autocomplete")._renderMenu = function (ul, data) {
  var kitaplar = "";
  var yazarlar = "";
  var yayinevleri = "";

  $.each(data, function (index, item) {
    var pttkitapdurum = item.value[index].pttkitapdurum;

    var urunadi = item.value[index].NAME;

    if (urunadi == 'YazarAra') {
      yazarlar += '<li style="cursor:pointer; " class="col-xs-7 col-sm-7 col-md-7 col-lg-7 items-holder no-margin" ><div style="margin-left:0px;" class="row no-margin cart-item padding-7-0-4 "><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 overflow-hidden body"><div class="title">' + $('<div/>').html(item.value[index].Yazar.substring(0, item.value[index].Yazar.length - 1)).text().replace('<a', '<a class="color_dark f_size_large"') + '</div></div></div></li>';
    } else if (urunadi == 'YayineviAra') {
      yayinevleri += '<li style="cursor:pointer; " class="col-xs-7 col-sm-7 col-md-7 col-lg-7 items-holder no-margin" ><div style="margin-left:0px;" class="row no-margin cart-item padding-7-0-4 "><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 overflow-hidden body"><div class="title"><a class="color_dark f_size_large">' + $('<div/>').html(item.value[index].Yayinevi.substring(0, item.value[index].Yayinevi.length - 1)).text().replace('<a', '<a class="color_dark f_size_large"') + '</a></div></div></div></li>';


    } else {


      kitaplar += '<li style="cursor:pointer; " class="col-xs-7 col-sm-7 col-md-7 col-lg-7 items-holder no-margin" onclick="gotur(\'/Istem/Urun/Detay.aspx?Id=' + item.value[index].urunId + '\')"><div style="margin-left:0px;" class="row no-margin cart-item padding-7-0-4 "><div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 overflow-hidden body"><div class="title"><a class="color_dark f_size_large">' + item.value[index].NAME + '</a></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-2"><div class="price-current text-right"><span class="para">' + item.value[index].PRICE + ' TL</span></div></div></div></li>';






    }



  });

  if (kitaplar != "") {
    $(ul).append('<div style="width:100%; text-align:left; margin-top:10px; " class="ui-menu-item row" id="ui-id-7" tabindex="-1"> <a class="Menu_color_reda  f_size_large col-md-12"><b>Ürünler</b></a></div>' + kitaplar);

  }
  if (yazarlar != "") {
    $(ul).append('<div style="width:100%; text-align:left; margin-top:10px; " class="ui-menu-item row" id="ui-id-7" tabindex="-1"> <a class="Menu_color_reda  f_size_large col-md-12"><b>Yazarlar</b></a></div>' + yazarlar);
  }
  if (yayinevleri != "") {
    $(ul).append('<div style="width:100%; text-align:left; margin-top:10px;  " class="ui-menu-item row" id="ui-id-7" tabindex="-1"> <a class="Menu_color_reda  f_size_large col-md-12"><b>Yayınevleri</b></a></div>' + yayinevleri);

  }






  $(ul).append('<div style="width:100%; text-align:center; margin-top:10px; margin-bottom:10px;"><a style="cursor:pointer;" onclick="TumunuGoster()">Tümünü Göster</a></div>');
};

function gotur(url) {
  window.location.href = url;
}

function TumunuGoster() {
  if ($.trim($("#txtArama").val()).length == 13 & parseFloat($.trim($("#txtArama").val())) > 0) {
    window.location.href = '/Istem/Urun/Detay.aspx?Barcode=' + $.trim($("#txtArama").val());
  } else {
    window.location.href = '/Istem/Urun/Listele.aspx?ara=' + $("#txtArama").val() + '&yazar=0&yayinEvi=0&ilk=1';
  }
}

//$(window).resize(function () {
//    var width = $(window).width();
//    if (width < 768) {
//        $("#filtrecollapse").removeClass("in")
//    }
//    else {$("#filtrecollapse").addClass("in")}
//});
$(document).ready(function () {
  var width = $(window).width();
  if (width < 768) {
    $("#filtrecollapse").removeClass("in")
  } else {
    $("#filtrecollapse").addClass("in")
  }
})

function Sayfakapat() {

  $("#spnurunbekleyenadet").val("");
  $("#spnurunfaturalananadet").val("");
  $('#divGiris').bPopup().close();

  return false;
}

function SepeteEklekontrol(urunId, barkod, ithalat, birimfiyat, indirimli, kdv, birim, indirim1, txtAdet1, kimyazdi) {
  Sayfakapat();



  return false;
}

function popupAc() {
  $('#divGiris').bPopup({
    appendTo: 'form',
    zIndex: 999,
    modalClose: true
  });
}
$(document).ready(function () {
  $('[data-toggle="popover"]').popover();
});

$(document).on("change", "[id ^= filter1]", function (e) {

  var slcsecim = $("#ContentPlaceHolder1_drpsiralama").val();

  var checkedd = this.checked;

  var valuee = this.value;

  $.ajax({
    type: 'POST',
    url: '/WebMethods.aspx/CookieEkleSecim',
    data: '{"slcsecim":"' + slcsecim + '","secimad":"ara"}',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (result) {

    },
    error: function (resultx) {},
    complete: function () {
      if (checkedd == true) {
        window.location.href = '/default.aspx?dersId=' + getParameterByName("dersId") + '&yayinEvi=9428&sinif=' + getParameterByName("sinif") + '&yazar=' + getParameterByName("yazar") + '';
      } else {
        window.location.href = '/default.aspx?dersId=' + getParameterByName("dersId") + '&yayinEvi=0&sinif=' + getParameterByName("sinif") + '&yazar=' + getParameterByName("yazar") + '';
      }

    }
  });


});

$(document).on("change", "[id ^= filter2]", function (e) {

  var slcsecim = $("#ContentPlaceHolder1_drpsiralama").val();

  var checkedd = this.checked;

  var valuee = this.value;

  $.ajax({
    type: 'POST',
    url: '/WebMethods.aspx/CookieEkleSecim',
    data: '{"slcsecim":"' + slcsecim + '","secimad":"ara"}',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (result) {

    },
    error: function (resultx) {},
    complete: function () {
      if (checkedd == true) {
        window.location.href = '/default.aspx?dersId=' + getParameterByName("dersId") + '&yayinEvi=9427&sinif=' + getParameterByName("sinif") + '&yazar=' + getParameterByName("yazar") + '';
      } else {
        window.location.href = '/default.aspx?dersId=' + getParameterByName("dersId") + '&yayinEvi=0&sinif=' + getParameterByName("sinif") + '&yazar=' + getParameterByName("yazar") + '';
      }

    }
  });


});

$(document).on("change", "[id ^= chcders]", function (e) {


  var slcsecim = $("#ContentPlaceHolder1_drpsiralama").val();

  var checkedd = this.checked;

  var valuee = this.value;

  $.ajax({
    type: 'POST',
    url: '/WebMethods.aspx/CookieEkleSecim',
    data: '{"slcsecim":"' + slcsecim + '","secimad":"ara"}',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (result) {

    },
    error: function (resultx) {},
    complete: function () {
      if (checkedd == true) {

        window.location.href = '/default.aspx?dersId=' + (getParameterByName("dersId") == "0" ? valuee + ',' : getParameterByName("dersId") + valuee + ',') + '&yayinEvi=' + getParameterByName("yayinEvi") + '&sinif=' + getParameterByName("sinif") + '&yazar=' + getParameterByName("yazar") + '';
      } else {
        window.location.href = '/default.aspx?ders=' + (getParameterByName("dersId").replace(valuee + ',', '') == '' ? '0' : getParameterByName("dersId").replace(valuee + ',', '')) + '&yayinEvi=' + getParameterByName("yayinEvi") + '&sinif=' + getParameterByName("sinif") + '&yazar=' + getParameterByName("yazar") + '';
      }

    }
  });


});

$(document).on("change", "[id ^= chcsinif]", function (e) {


  var slcsecim = $("#ContentPlaceHolder1_drpsiralama").val();

  var checkedd = this.checked;

  var valuee = this.value;

  $.ajax({
    type: 'POST',
    url: '/WebMethods.aspx/CookieEkleSecim',
    data: '{"slcsecim":"' + slcsecim + '","secimad":"ara"}',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (result) {

    },
    error: function (resultx) {},
    complete: function () {
      if (checkedd == true) {

        window.location.href = '/default.aspx?dersId=' + getParameterByName("dersId") + '&yayinEvi=' + getParameterByName("yayinEvi") + '&sinif=' + (getParameterByName("sinif") == "0" ? valuee + ',' : getParameterByName("sinif") + valuee + ',') + '&yazar=' + getParameterByName("yazar") + '';
      } else {
        window.location.href = '/default.aspx?dersId=' + getParameterByName("dersId") + '&yayinEvi=' + getParameterByName("yayinEvi") + '&sinif=' + (getParameterByName("sinif").replace(valuee + ',', '') == '' ? '0' : getParameterByName("sinif").replace(valuee + ',', '')) + '&yazar=' + getParameterByName("yazar") + '';
      }

    }
  });


});


$(document).on("change", "[id ^= chcyazar]", function (e) {


  var slcsecim = $("#ContentPlaceHolder1_drpsiralama").val();

  var checkedd = this.checked;

  var valuee = this.value;

  $.ajax({
    type: 'POST',
    url: '/WebMethods.aspx/CookieEkleSecim',
    data: '{"slcsecim":"' + slcsecim + '","secimad":"ara"}',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (result) {

    },
    error: function (resultx) {},
    complete: function () {
      if (checkedd == true) {

        window.location.href = '/default.aspx?dersId=' + getParameterByName("dersId") + '&yayinEvi=' + getParameterByName("yayinEvi") + '&sinif=' + getParameterByName("sinif") + '&yazar=' + (getParameterByName("yazar") == "0" ? valuee + ',' : getParameterByName("yazar") + valuee + ',') + '';
      } else {
        window.location.href = '/default.aspx?dersId=' + getParameterByName("dersId") + '&yayinEvi=' + getParameterByName("yayinEvi") + '&sinif=' + getParameterByName("sinif") + '&yazar=' + (getParameterByName("yazar").replace(valuee + ',', '') == '' ? '0' : getParameterByName("yazar").replace(valuee + ',', '')) + '';
      }

    }
  });


});
